// TODO : Need translation
// Options for account type dropdown
export const ACCOUNT_OPTIONS = [
  { value: "Savings", isEnabled: true },
  { value: "Current", isEnabled: true },
];
